export default __webpack_public_path__ + "static/media/features_card6.de8239fa.svg";